function matchesDayTimeRestrictions(restrictions, period) {
  const startDateTime = new Date(period.startDateTime || period)
  const dayOfWeek = startDateTime
    .toLocaleString('en-US', {
      weekday: 'long',
      timeZone: 'UTC',
    })
    .toUpperCase()
  const startDate = getDate(startDateTime)
  let startTime = stringifyDate(startDateTime.getUTCHours(), startDateTime)
  let startTimeMs
  let restrictionStartTime
  let restrictionEndTime

  if (restrictions.startTime) {
    restrictionStartTime = stringifyDate(
      new Date(restrictions.startTime).getUTCHours(),
      new Date(restrictions.startTime),
    )
  }
  if (restrictions.endTime) {
    restrictionEndTime = stringifyDate(
      new Date(restrictions.endTime).getUTCHours(),
      new Date(restrictions.endTime),
    )
  }
  if (
    restrictions.startTime &&
    restrictions.endTime &&
    getTimeOfDayMs(restrictionStartTime) > getTimeOfDayMs(restrictionEndTime)
  ) {
    restrictionEndTime = stringifyDate(
      new Date(restrictions.endTime).getUTCHours() + 24,
      new Date(restrictions.endTime),
    )

    if (
      startDateTime.getUTCHours() >= 0 &&
      startDateTime.getUTCHours() <=
        new Date(restrictions.endTime).getUTCHours()
    ) {
      startTime = stringifyDate(startDateTime.getUTCHours() + 24, startDateTime)
    }
  } else if (
    restrictions.endTime &&
    new Date(restrictions.endTime).getUTCHours() === 0
  )
    restrictionEndTime = stringifyDate(
      new Date(restrictions.endTime).getUTCHours() + 24,
      new Date(restrictions.endTime),
    )

  startTimeMs = getTimeOfDayMs(startTime)
  if (
    restrictions.startTime &&
    startTimeMs < getTimeOfDayMs(restrictionStartTime)
  )
    return false
  if (restrictions.endTime && startTimeMs >= getTimeOfDayMs(restrictionEndTime))
    return false

  if (
    restrictions.startDate &&
    new Date(startDate) < new Date(getDate(new Date(restrictions.startDate)))
  )
    return false
  if (
    restrictions.endDate &&
    new Date(startDate) >= new Date(getDate(new Date(restrictions.endDate)))
  )
    return false

  if (restrictions.dayOfWeek && !restrictions.dayOfWeek.includes(dayOfWeek))
    return false

  return true
}
const getTimeOfDayMs = (timeString) => {
  const [hoursStr, minutesStr, secondsStr] = timeString.split(':')
  const hours = parseInt(hoursStr, 10)
  const minutes = parseInt(minutesStr, 10)
  const seconds = parseInt(secondsStr, 10)

  return hours * 3600000 + minutes * 60000 + seconds * 1000
}
const stringifyDate = (hours, date) => {
  const paddedTimeString = [
    hours.toString().padStart(2, '0'),
    date.getUTCMinutes().toString().padStart(2, '0'),
    date.getUTCSeconds().toString().padStart(2, '0'),
  ].join(':')
  return paddedTimeString
}
const getDate = (date) => date.toISOString().split('T')[0]

const sameDate = (a, b) => {
  if (!a && !b) return true
  if (!a || !b) return false

  const dateA = a instanceof Date ? a : new Date(a)
  const dateB = b instanceof Date ? b : new Date(b)
  return dateA.getTime() === dateB.getTime()
}

const timeIn24 = (ts) =>
  new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(ts)

module.exports = {
  matchesDayTimeRestrictions,
  sameDate,
  timeIn24,
}
